<script>
export default {
  name: 'ImageLoader',
  props: {
    url: { type: String, required: true },
    animation: {
      type: Object,
      default: () => ({
        opacity: {
          start: 0,
          end: 1,
          duration: 150
        },
        blur: {
          start: '20px',
          end: '0px',
          duration: 150
        }
      })
    }
  },
  data: () => ({
    loaded: false
  }),
  computed: {
    hasClickListener () {
      return this.$listeners && this.$listeners.click
    },
    styles () {
      return {
        image: {
          '--cursor': this.hasClickListener ? 'pointer' : 'default',
          '--background-color': this.backgroundColor,
          '--url': `url(${this.url})`,
          '--opacity': !this.loaded
            ? this.animation.opacity.start
            : this.animation.opacity.end,
          '--blur': !this.loaded
            ? this.animation.blur.start
            : this.animation.blur.end,
          '--transition': `opacity ${this.animation.opacity.duration}ms linear,
                           filter ${this.animation.blur.duration}ms linear
                          `
        }
      }
    }
  },
  mounted () {
    var img = new Image()
    img.onload = () => (this.loaded = true)
    img.src = this.url
  }
}
</script>

<template>
  <div
    class="image"
    :style="styles.image"
    @click="e => $emit('click', e)"
  />
</template>

<style lang="scss" scoped>
.image {
  background-image: var(--url);
  opacity: var(--opacity);
  filter: blur(var(--blur));
  transition: var(--transition);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: var(--cursor);
}
</style>
